module.exports = __webpack_public_path__ + "img/20171229_174141.08c52b50.jpg";